import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";

export default function Login({ setToken }) {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);

  const handleSubmit = (e) => {
    setMessage("");
    setLoading(true);
    e.preventDefault();
    const loginData = {
      username: username,
      password: password,
    };

    axios
      // .post(process.env.REACT_APP_API_BASE_URL + "/wp-json/jwt-auth/v1/token", loginData) // JWT Auth & JWT Authentication for WP-API
      .post(process.env.REACT_APP_API_BASE_URL + "/wp-json/api/v1/token", loginData) // miniOrange JWT Authentication
      .then((response) => {
        setToken(response.data.jwt_token); // miniOrange JWT Authentication
        // setToken(response.data.data.token); // JWT Auth
        // setToken(response.data.token); // JWT Authentication for WP-API
      })
      .catch((error) => {
        // setUserName();
        // setPassword();
        setLoading(false);
        setMessage(error.response?.data?.message || error.response?.data?.error || error.message);
        setAlertVisible(true);
        setTimeout(() => {
          setAlertVisible(false);
        }, 2000);
      });
  };

  return (
    <Modal centered show backdrop="static" className="login-backdrop">
      <Form onSubmit={handleSubmit}>
        <Modal.Header className="login-header">
          <p className="eyebrow">RideGauge</p>
          <Modal.Title>Welcome back</Modal.Title>
          <p>Sign in to log your next fuel stop.</p>
        </Modal.Header>
        <Modal.Body className="login-body">
          <Alert show={alertVisible} variant="danger" dismissible>
            <Alert.Heading>Login failed</Alert.Heading>
            {message}
          </Alert>

          <Form.Group className="mb-3">
            <Form.Label>Username</Form.Label>
            <Form.Control autoFocus autoComplete="username" onChange={(e) => setUserName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="login-footer">
          {isLoading ? (
            <Button size="lg" disabled>
              <Spinner size="sm" />
              Signing in…
            </Button>
          ) : (
            <Button size="lg" type="submit">
              Sign in
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
